export default "__VITE_ASSET__c16bd05f__"